import { useState, useEffect, useRef } from "react";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter, formatValue } from "../../utils/utils";
import LoadSimple from "../LoadSimple";
import ModalDeleteRol from "./ModalDeleteRol";
import Modal from 'react-modal';

const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};

const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "80%",
    padding: "20px",
  },
};

const RolesList = ({
  handleShowPopup, getRoles, handleChangEdit, server, languaje, mode,
  setHostSelected, hostSelected, openAddHostModal, showHistoric,
  pageActual, limitList, SelectRol, setPages, setLimitList, setPageActual,
  startLimit, setTotalRecord, listSelected, dataDevices, setDataDevices,
  dataCriticalities, dataAgencies, searchTerm, setSearchTerm, dataServers, dataList
}) => {
  const [msgError, setMsgError] = useState("");
  const [data, setData] = useState([]);
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({});

  // Estado: qué cards tienen módulos expandidos. Map: { [rolId-moduleId]: bool }
  const [expandedModules, setExpandedModules] = useState({});

  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setDeleteUserModalOpen(false);
  }

  const handledeleteUserClick = (data) => {
    openDeleteUserModal();
    setUserSelected(data);
  };

  const toggleModule = (rolId, moduleId) => {
    const key = `${rolId}-${moduleId}`;
    setExpandedModules(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // ═══════════════════════════════════════════════════════════════════════
  // PALETA CLEAN BLUE
  // ═══════════════════════════════════════════════════════════════════════
  const C = {
    bl: '#1a56db',
    blDark: '#0f2d5e',
    bl5: '#e8f0fe',
    txt: '#0f172a',
    txt2: '#334155',
    txt3: '#64748b',
    txt4: '#94a3b8',
    b1: '#e2e8f0',
    b2: '#cbd5e1',
    bg: '#f8fafc',
    bg2: '#f1f5f9',
    wh: '#ffffff',
    red: '#e02424',
    redSoft: '#fef2f2',
  };

  return (
    <>
      <div className="main-cont-graf-monitor">
        <div className="compact-graf-monitor">
          {(dataDevices.loading) ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
              <LoadSimple />
            </div>
          ) : (
            <section
              className='FlexContainerIndividuals'
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: 16,
                padding: 16,
                width: '100%',
                boxSizing: 'border-box',
              }}
            >
              {(dataDevices.data.length == 0 && dataDevices.loading == false) ? (
                msgError == "" ? (
                  <div style={{
                    gridColumn: '1 / -1',
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    padding: 60, color: C.txt3, fontSize: 14,
                    background: C.wh, border: `1px dashed ${C.b1}`, borderRadius: 12,
                  }}>
                    {capitalizeFirstLetter(lang[languaje]['sinResultados'] || 'Sin resultados')}
                  </div>
                ) : (
                  <div style={{
                    gridColumn: '1 / -1',
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    padding: 60, color: C.red, fontSize: 14,
                    background: C.redSoft, border: `1px solid ${C.red}`, borderRadius: 12,
                  }}>
                    {msgError}
                  </div>
                )
              ) : (
                dataList.map((element, hostIndex) => {
                  const modulosPermitidos = element.permissions.filter(e => e.Nivel === 1);
                  const isProtected = element.rol_id === 1 || element.rol_id === 2;

                  return (
                    <div
                      key={element.rol_id || hostIndex}
                      style={{
                        background: C.wh,
                        border: `1px solid ${C.b1}`,
                        borderRadius: 12,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 1px 3px rgba(15,45,94,0.06)',
                        transition: 'box-shadow 0.15s, border-color 0.15s, transform 0.15s',
                        cursor: 'default',
                        height: 380,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(15,45,94,0.12)';
                        e.currentTarget.style.borderColor = C.b2;
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(15,45,94,0.06)';
                        e.currentTarget.style.borderColor = C.b1;
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      {/* ════════════════════════════════════════════════════════
                          HEADER AZUL MARINO
                          ════════════════════════════════════════════════════════ */}
                      <div
                        style={{
                          background: C.blDark,
                          padding: '14px 16px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                          flexShrink: 0,
                        }}
                      >
                        <div
                          style={{
                            width: 32, height: 32, borderRadius: 8,
                            background: 'rgba(255,255,255,0.12)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 7h-9" />
                            <path d="M14 17H5" />
                            <circle cx="17" cy="17" r="3" />
                            <circle cx="7" cy="7" r="3" />
                          </svg>
                        </div>

                        <div style={{
                          flex: 1, minWidth: 0,
                          color: C.wh, fontSize: 14, fontWeight: 600,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}
                          title={element.name}
                        >
                          {element.name}
                        </div>

                        {isProtected && (
                          <span
                            style={{
                              background: 'rgba(255,255,255,0.15)',
                              color: C.wh,
                              fontSize: 10,
                              fontWeight: 600,
                              padding: '3px 8px',
                              borderRadius: 999,
                              letterSpacing: '0.04em',
                              textTransform: 'uppercase',
                              flexShrink: 0,
                            }}
                            title={capitalizeFirstLetter(lang[languaje]['rolSistema'] || 'Rol del sistema')}
                          >
                            {capitalizeFirstLetter(lang[languaje]['sistema'] || 'Sistema')}
                          </span>
                        )}
                      </div>

                      {/* ════════════════════════════════════════════════════════
                          BADGE DE CONTEO
                          ════════════════════════════════════════════════════════ */}
                      <div
                        style={{
                          padding: '10px 16px',
                          background: C.bg,
                          borderBottom: `1px solid ${C.b1}`,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          flexShrink: 0,
                        }}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            background: element.permissions.length > 0 ? C.bl5 : C.bg2,
                            color: element.permissions.length > 0 ? C.bl : C.txt3,
                            padding: '4px 10px',
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 600,
                          }}
                        >
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                          {element.permissions.length}
                        </span>
                        <span style={{ fontSize: 12, color: C.txt3, fontWeight: 500 }}>
                          {capitalizeFirstLetter(lang[languaje]['selectPermisos'] || 'permisos asignados')}
                        </span>
                      </div>

                      {/* ════════════════════════════════════════════════════════
                          ÁRBOL DE PERMISOS
                          ════════════════════════════════════════════════════════ */}
                      <div
                        style={{
                          flex: 1,
                          overflow: 'auto',
                          padding: '8px 12px',
                          background: C.wh,
                          minHeight: 0,
                        }}
                      >
                        {modulosPermitidos.length === 0 ? (
                          <div style={{
                            display: 'flex', flexDirection: 'column',
                            alignItems: 'center', justifyContent: 'center',
                            height: '100%', color: C.txt4, fontSize: 12,
                            gap: 8, padding: 20,
                          }}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={C.txt4} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="11" width="18" height="11" rx="2" />
                              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                            {capitalizeFirstLetter(lang[languaje]['sinResultados'] || 'Sin permisos asignados')}
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            {modulosPermitidos.map((module, moduleIndex) => {
                              const submodulos = element.permissions.filter(
                                el => el.Nivel === 2 && el.name == module.module_name
                              );
                              const moduleKey = `${element.rol_id || hostIndex}-${module.permission_id || moduleIndex}`;
                              const isExpanded = expandedModules[moduleKey] || false;
                              const moduleLabel = capitalizeFirstLetter(
                                module.module_name in lang[languaje]
                                  ? lang[languaje][module.module_name]
                                  : module.module_name
                              );

                              return (
                                <div key={module.permission_id || `mod-${moduleIndex}`}>
                                  {/* MÓDULO (nivel 1) */}
                                  <div
                                    onClick={() => submodulos.length > 0 && toggleModule(element.rol_id || hostIndex, module.permission_id || moduleIndex)}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 8,
                                      padding: '6px 8px',
                                      borderRadius: 6,
                                      cursor: submodulos.length > 0 ? 'pointer' : 'default',
                                      background: isExpanded ? C.bg2 : 'transparent',
                                      transition: 'background 0.12s',
                                    }}
                                    onMouseEnter={(e) => {
                                      if (submodulos.length > 0) e.currentTarget.style.background = C.bg2;
                                    }}
                                    onMouseLeave={(e) => {
                                      if (!isExpanded) e.currentTarget.style.background = 'transparent';
                                    }}
                                  >
                                    {submodulos.length > 0 ? (
                                      <svg
                                        width="11" height="11" viewBox="0 0 24 24" fill="none"
                                        stroke={C.txt3} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                                        style={{
                                          flexShrink: 0,
                                          transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                          transition: 'transform 0.15s',
                                        }}
                                      >
                                        <polyline points="9 18 15 12 9 6" />
                                      </svg>
                                    ) : (
                                      <span style={{
                                        width: 11, height: 11, flexShrink: 0,
                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                      }}>
                                        <span style={{ width: 4, height: 4, borderRadius: '50%', background: C.bl }} />
                                      </span>
                                    )}

                                    <span style={{
                                      fontSize: 13,
                                      fontWeight: 600,
                                      color: C.blDark,
                                      flex: 1,
                                      minWidth: 0,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}>
                                      {moduleLabel}
                                    </span>

                                    {submodulos.length > 0 && (
                                      <span style={{
                                        fontSize: 10,
                                        fontWeight: 600,
                                        background: C.bl5,
                                        color: C.bl,
                                        padding: '1px 7px',
                                        borderRadius: 999,
                                        flexShrink: 0,
                                      }}>
                                        {submodulos.length}
                                      </span>
                                    )}
                                  </div>

                                  {/* SUBMÓDULOS (nivel 2) */}
                                  {isExpanded && submodulos.map((submodule, submoduleIndex) => {
                                    const caracteristicas = element.permissions.filter(
                                      ele => ele.Nivel === 3
                                        && ele.name === module.module_name
                                        && ele.description === submodule.module_name
                                    );
                                    const subLabel = capitalizeFirstLetter(
                                      submodule.module_name in lang[languaje]
                                        ? lang[languaje][submodule.module_name]
                                        : submodule.module_name
                                    );

                                    return (
                                      <div key={submodule.permission_id || `sub-${submoduleIndex}`}>
                                        <div style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 8,
                                          padding: '4px 8px 4px 28px',
                                        }}>
                                          <span style={{
                                            width: 4, height: 4, borderRadius: '50%',
                                            background: C.txt4, flexShrink: 0,
                                          }} />
                                          <span style={{
                                            fontSize: 12,
                                            fontWeight: 500,
                                            color: C.txt2,
                                            flex: 1,
                                            minWidth: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}>
                                            {subLabel}
                                          </span>
                                          {caracteristicas.length > 0 && (
                                            <span style={{
                                              fontSize: 9,
                                              fontWeight: 600,
                                              color: C.txt3,
                                              flexShrink: 0,
                                            }}>
                                              ({caracteristicas.length})
                                            </span>
                                          )}
                                        </div>

                                        {/* CARACTERÍSTICAS (nivel 3) */}
                                        {caracteristicas.length > 0 && (
                                          <div style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 4,
                                            padding: '2px 8px 4px 44px',
                                          }}>
                                            {caracteristicas.map((caracter, caracterIndex) => {
                                              const charLabel = capitalizeFirstLetter(
                                                lang[languaje][caracter.module_name] == undefined
                                                  ? caracter.module_name
                                                  : lang[languaje][caracter.module_name]
                                              );
                                              return (
                                                <span
                                                  key={caracter.permission_id || `char-${caracterIndex}`}
                                                  style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    padding: '2px 8px',
                                                    background: C.bl5,
                                                    color: C.bl,
                                                    borderRadius: 999,
                                                    fontSize: 10,
                                                    fontWeight: 500,
                                                  }}
                                                >
                                                  {charLabel}
                                                </span>
                                              );
                                            })}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      {/* ════════════════════════════════════════════════════════
                          FOOTER — Acciones
                          ════════════════════════════════════════════════════════ */}
                      <div
                        style={{
                          padding: '10px 16px',
                          borderTop: `1px solid ${C.b1}`,
                          background: C.bg,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          gap: 8,
                          flexShrink: 0,
                          minHeight: 48,
                        }}
                      >
                        {isProtected ? (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            fontSize: 11,
                            color: C.txt3,
                            fontStyle: 'italic',
                          }}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="11" width="18" height="11" rx="2" />
                              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                            {capitalizeFirstLetter(lang[languaje]['rolNoEditable'] || 'Rol protegido')}
                          </div>
                        ) : (
                          <>
                            <button
                              onClick={() => { SelectRol(element.rol_id); handleChangEdit(element); }}
                              style={{
                                width: 32, height: 32, borderRadius: 8,
                                border: `1px solid ${C.b1}`,
                                background: C.wh,
                                color: C.bl,
                                cursor: 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                transition: 'all 0.15s',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = C.bl5;
                                e.currentTarget.style.borderColor = C.bl;
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = C.wh;
                                e.currentTarget.style.borderColor = C.b1;
                              }}
                              title={capitalizeFirstLetter(lang[languaje]['editar'] || 'Editar')}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                              </svg>
                            </button>

                            <button
                              onClick={(e) => { e.stopPropagation(); handledeleteUserClick(element); }}
                              style={{
                                width: 32, height: 32, borderRadius: 8,
                                border: `1px solid ${C.b1}`,
                                background: C.wh,
                                color: C.red,
                                cursor: 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                transition: 'all 0.15s',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = C.redSoft;
                                e.currentTarget.style.borderColor = C.red;
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = C.wh;
                                e.currentTarget.style.borderColor = C.b1;
                              }}
                              title={capitalizeFirstLetter(lang[languaje]['eliminar'] || 'Eliminar')}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                <path d="M10 11v6" />
                                <path d="M14 11v6" />
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                              </svg>
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })
              )}

              {dataList.length == 0 && !dataDevices.loading && (
                <div style={{
                  gridColumn: '1 / -1',
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  padding: 60, color: C.txt3, fontSize: 14, gap: 10,
                  background: C.wh, border: `1px dashed ${C.b1}`, borderRadius: 12,
                }}>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke={C.txt4} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  {capitalizeFirstLetter(lang[languaje]['sinResultados'] || 'Sin resultados')}
                </div>
              )}
            </section>
          )}
        </div>
      </div>

      <Modal
        isOpen={deleteUserModalOpen}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      >
        <ModalDeleteRol
          languaje={languaje}
          mode={mode}
          server={server}
          setData={setData}
          getRoles={getRoles}
          user={userSelected}
          closDeleteUserModal={closDeleteUserModal}
        />
      </Modal>
    </>
  );
};

export default RolesList;